import axiosInstance from "./AxiosInstance"

// Get Patient Male Chart List
export function getPatientMaleChart(patient_id) {
  try {
    return axiosInstance.post("patient/malechartList", {
      patient_id,
    })
  } catch (error) {
    console.error("Error fetching patient male charts:", error)
    throw error
  }
}

// Create Patient Male Chart
export function createPatientMaleChart(data) {
  try {
    return axiosInstance.post("/patient/addMaleChart", data)
  } catch (error) {
    console.error("Error creating patient male chart:", error)
    throw error
  }
}

// Update Patient Male Chart
export function updatePatientMaleChart(data) {
  try {
    return axiosInstance.post("/patient/editMaleChart", data)
  } catch (error) {
    console.error("Error updating patient male chart:", error)
    throw error
  }
}

// Delete Patient Male Chart
export function deletePatientMaleChart(data) {
  try {
    return axiosInstance.post("/patient/deleteMaleChart", data)
  } catch (error) {
    console.error("Error deleting patient male chart:", error)
    throw error
  }
}

// Format Patient Male Chart Response Data
export function formatPatientMaleChart(responseData) {
  if (!responseData) return []

  // Handle array of charts
  if (Array.isArray(responseData)) {
    return responseData.map((entry) => formatSingleChart(entry))
  }

  // Handle single chart object
  if (responseData && typeof responseData === "object" && !Array.isArray(responseData)) {
    return formatSingleChart(responseData)
  }

  return []
}

// Format single chart entry
function formatSingleChart(entry) {
  if (!entry) return null

  return {
    chart_id: entry.male_chart_id || entry.chart_id,
    patient_id: entry.patient_id,
    date: formatDateField(entry.malechart_date),
    symptoms: formatSymptomsField(entry.symptoms_intercourse, entry.other_name),
    other_name: entry.other_name || "",
    metallicColor: entry.metalic_color || entry.metallicColor || "",
    by_patient: entry.by_patient || "",
    status: entry.male_chart_status || "Active",
    created_at: entry.created_at,
    updated_at: entry.updated_at,
  }
}

// Format symptoms field
function formatSymptomsField(symptoms, otherName) {
  if (!symptoms) return ""

  let formattedSymptoms = []

  if (typeof symptoms === "string") {
    // Split by "||" delimiter as returned by the API
    formattedSymptoms = symptoms.split("||").filter((s) => s.trim())
  } else if (Array.isArray(symptoms)) {
    formattedSymptoms = [...symptoms]
  }

  // Add other_name if present
  if (otherName && otherName.trim()) {
    formattedSymptoms.push(otherName)
  }

  return formattedSymptoms.join(", ")
}

// Format date field
function formatDateField(dateStr) {
  if (!dateStr) return { day: "", year: "" }

  try {
    const dateObj = new Date(dateStr)

    if (isNaN(dateObj.getTime())) {
      return { day: "", year: "" }
    }

    return {
      day: dateObj.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
      }),
      year: dateObj.getFullYear().toString(),
    }
  } catch (error) {
    console.error("Error formatting date:", error)
    return { day: "", year: "" }
  }
}

// Validate chart data before API calls
export function validateChartData(data) {
  const errors = []

  if (!data.patient_id) {
    errors.push("Patient ID is required")
  }

  if (!data.malechart_date) {
    errors.push("Chart date is required")
  }

  if (
    !data.symptoms_intercourse ||
    (Array.isArray(data.symptoms_intercourse) && data.symptoms_intercourse.length === 0)
  ) {
    errors.push("Symptoms are required")
  }

  return {
    isValid: errors.length === 0,
    errors,
  }
}
